// https://icons.getbootstrap.com/
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.min.js";

import React from "react";
import './Sidebar.css';

const style = {
  width: "280px",
};

function Sidebar() {
  return (
    <div
      className="d-flex flex-column flex-shrink-0 p-3 bg-light"
      style={style}
    >
      <a
        href="/"
        className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none"
      >
        <svg className="bi pe-none me-2" width="40" height="32">
          <use xlinkHref="#bootstrap" />
        </svg>
        <span className="fs-4">Marc Houben</span>
      </a>
      <hr />
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item">
          <a
            href="https://www.youtube.com/"
            className="nav-link active"
            aria-current="page"
          >
            <svg className="bi pe-none me-2" width="16" height="16">
              <use xlinkHref="#home" />
            </svg>
            <i className="bi bi-house-door"></i> Home
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/" className="nav-link link-dark">
            <svg className="bi pe-none me-2" width="16" height="16">
              <use xlinkHref="#speedometer2" />
            </svg>
            <i className="bi bi-at"></i> Email
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/" className="nav-link link-dark">
            <svg className="bi pe-none me-2" width="16" height="16">
              <use xlinkHref="#table" />
            </svg>
            <i className="bi bi-newspaper"></i> Nieuws
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/" className="nav-link link-dark">
            <svg className="bi pe-none me-2" width="16" height="16">
              <use xlinkHref="#grid" />
            </svg>
            <i className="bi bi-person-vcard"></i> Personalia
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/" className="nav-link link-dark">
            <svg className="bi pe-none me-2" width="16" height="16">
              <use xlinkHref="#people-circle" />
            </svg>
            <i className="bi bi-paypal"></i> Paypal
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;